import Bouncer from 'formbouncerjs';
import { message } from './constant';

export default new class Validation {
  constructor() {
    this.formForValidationSelector = '._required';
    this.inValidSelector = '_invalid';

    this.handler();
  }

  handler() {
    document.addEventListener('DOMContentLoaded', () => {
      this.validate(this.formForValidationSelector);
    });
  }

  init() {
    this.validate(this.formForValidationSelector);
  }

  validate(selector) {
    this.validation = new Bouncer(selector, {
      fieldClass: 'validation-error',
      errorClass: 'validation-error__message',
      fieldPrefix: 'validation-error-',
      errorPrefix: 'validation-error-',
      messageAfterField: true,
      messageCustom: 'data-bouncer-message',
      messageTarget: 'data-bouncer-target',
      disableSubmit: true,
      message,
      // Error messages by error type
      messages: {
        patternMismatch: {
          email: 'Please enter a valid email address.'
        },
        wrongLength: true,
      },
    });

    document.addEventListener('bouncerFormValid', ({ target }) => {
      target.classList.remove(this.inValidSelector);
    });

    document.addEventListener('bouncerFormInvalid', ({ target }) => {
      target.classList.add(this.inValidSelector);
    });

    // Detect show error events
    document.addEventListener('bouncerShowError', (event) => {
      // The field with the error
      const erMessage = event.target.getAttribute('data-bouncer-message');
      const erClass = event.target.getAttribute('data-bouncer-target');

      // The error details
      const { errors } = event.detail;

      console.log(errors);

      if (errors.missingValue && erMessage !== null) {
        document.querySelector(`${erClass} > div`).textContent = erMessage;
      }
    }, false);
  }
}();
